// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateContact from './routes/contact';

// import Particles from 'particlesjs/dist/particles.min.js';
// import particlesJS from 'particles.js';
import 'particles.js/particles';
// import stickybits from 'stickybits';
import ScrollReveal from 'scrollreveal';
const particlesJS = window.particlesJS;
// const stickybits = window.stickybits;

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faClock, faMapMarkerAlt, faSearch, faCaretRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faClock, faMapMarkerAlt, faSearch, faCaretRight, faLinkedin, faChevronDown);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateContact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Wait until content is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Class toggle for mobile nav flyout
  var navToggle = document.getElementById('nav-toggle');
  var mobileNav = document.getElementById('nav-flyout')
  navToggle.addEventListener('click', () => {
    mobileNav.classList.toggle('off-screen');
  });

  // Toggle tab content visible/hidden
  var tabLink = document.getElementsByClassName('feature-tab-link');
  var tabContent = document.getElementsByClassName('feature-tab');

  function activeTab (el) {
    el.preventDefault();
    Array.prototype.forEach.call(tabLink, node => {
      node.classList.remove('active');
    });
    el.currentTarget.classList.add('active');
  }

  Array.prototype.forEach.call(tabLink, node => {
    node.addEventListener('click', activeTab)
  });

  Array.prototype.forEach.call(tabLink, function(el){

    el.addEventListener('click', function() {
      var tabContentItem = document.getElementById(el.dataset.target)
      tabContentItem.classList.add('show-tab');

      Array.prototype.forEach.call(tabContent, function(el) {
        if(el !== tabContentItem && el.classList.contains('show-tab')){
          el.classList.remove( 'show-tab' );
        }
      });
    });
  });

  //sticky items - js needed due to overflow-x on html and body
  // stickybits('.sticky-item', { stickyBitStickyOffset: 20, useStickyClasses: true });

  // Trigger scroll reveal
  ScrollReveal().reveal('.sr-in', {
		delay: 100,
		distance: '30px',
		scale: 0.97,
		interval: 100,
		afterReveal: addAnimation,
	});

	// adds the class "animating" to an element with the class "animate"
	// css is used to do the actual animation
	function addAnimation(el) {
		var addAnimateClass = el.querySelector('.animate');
		if(addAnimateClass != null){
			addAnimateClass.classList.add('animating');
		}
  }

  /* eslint-disable */
  var particlesParams = {
    "particles": {
      "number": {
        "value": 65,
        "density": {
          "enable": true,
          "value_area": 1000
        }
      },
      "color": {
        "value": "#ffffff"
      },
      "shape": {
        "type": "circle",
        "stroke": {
          "width": 0,
          "color": "#000000"
        },
        "polygon": {
          "nb_sides": 5
        },
        "image": {
          "src": "img/github.svg",
          "width": 100,
          "height": 100
        }
      },
      "opacity": {
        "value": 0.3,
        "random": false,
        "anim": {
          "enable": false,
          "speed": 1,
          "opacity_min": 0.1,
          "sync": false
        }
      },
      "size": {
        "value": 0,
        "random": true,
        "anim": {
          "enable": false,
          "speed": 40,
          "size_min": 0.1,
          "sync": false
        }
      },
      "line_linked": {
        "enable": true,
        "distance": 300,
        "color": "#ffffff",
        "opacity": 0.2,
        "width": 2
      },
      "move": {
        "enable": true,
        "speed": 3,
        "direction": "none",
        "random": false,
        "straight": false,
        "out_mode": "out",
        "bounce": false,
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      }
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "grab"
        },
        "onclick": {
          "enable": true,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 140,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 400,
          "size": 40,
          "duration": 2,
          "opacity": 8,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  };

  var particlesParamsDark = {
    "particles": {
      "number": {
        "value": 60,
        "density": {
          "enable": true,
          "value_area": 1000
        }
      },
      "color": {
        "value": "#E5E5E5"
      },
      "shape": {
        "type": "circle",
        "stroke": {
          "width": 0,
          "color": "#E5E5E5"
        },
        "polygon": {
          "nb_sides": 5
        },
        "image": {
          "src": "img/github.svg",
          "width": 100,
          "height": 100
        }
      },
      "opacity": {
        "value": 1,
        "random": false,
        "anim": {
          "enable": false,
          "speed": 1,
          "opacity_min": 0.075,
          "sync": false
        }
      },
      "size": {
        "value": 0,
        "random": true,
        "anim": {
          "enable": false,
          "speed": 20,
          "size_min": 0.1,
          "sync": false
        }
      },
      "line_linked": {
        "enable": true,
        "distance": 300,
        "color": "#E5E5E5",
        "opacity": 1,
        "width": 2
      },
      "move": {
        "enable": true,
        "speed": 1.5,
        "direction": "none",
        "random": false,
        "straight": false,
        "out_mode": "out",
        "bounce": false,
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      }
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "grab"
        },
        "onclick": {
          "enable": false,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 140,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 400,
          "size": 40,
          "duration": 2,
          "opacity": 1,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  };

  window.onload = function() {
    // Load header particles
    if(document.getElementById('particles-js')){
      particlesJS("particles-js", particlesParams);
    };
    if(document.getElementById('particles-js-body-alt')){
      particlesJS("particles-js-body-alt", particlesParamsDark);
    };


    // check for multiple instances of body particles and fire multiple instances of particlesJS
    var bodyParticles = document.querySelectorAll("[id^='particles-js-body']");
    function fireParticles(item) {
      particlesJS(item.id, particlesParamsDark);
    }
    if(bodyParticles.length){
      for (var i = 0, len = bodyParticles.length; i < len; i++) {
        fireParticles(bodyParticles[i]);
      }
    }
  };
  /* eslint-enable */
});



// WEBPACK FOOTER //
// ./scripts/main.js